var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pTab",
    class: [_vm.isMobile && 'wap', _vm.type === 'grid' && 'grid', _vm.type === 'column' && 'column']
  }, [_c('div', {
    staticClass: "pTab-main",
    style: {
      width: _vm.width
    }
  }, _vm._l(_vm.tab, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pTab-item btn",
      class: _vm.selectTab === item.value && 'active',
      style: {
        flex: _vm.width == 'auto' ? 'none' : '1',
        '--tabActiveColor': _vm.tabActiveColor
      },
      on: {
        "click": function ($event) {
          return _vm.onTab(item);
        }
      }
    }, [_vm.isMobile && item.img ? _c('img', {
      attrs: {
        "src": require(`@images/ui/${item.img}.png`),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };